export default "__VITE_ASSET__a03af9f0__"